import React from 'react';
import Icon from '../../../components/AppIcon';

const ProjectStats = ({ projects }) => {
  const stats = {
    total: projects?.length,
    ongoing: projects?.filter(p => p?.status === 'ongoing')?.length,
    completed: projects?.filter(p => p?.status === 'completed')?.length,
    planned: projects?.filter(p => p?.status === 'planned')?.length,
    avgProgress: projects?.length > 0 ? Math.round(projects?.reduce((sum, p) => sum + p?.progress, 0) / projects?.length) : 0,
    totalMembers: projects?.reduce((sum, p) => sum + p?.memberCount, 0)
  };

  const statCards = [
    {
      title: 'إجمالي المشاريع',
      value: stats?.total,
      icon: 'FolderOpen',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      title: 'المشاريع الجارية',
      value: stats?.ongoing,
      icon: 'Play',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      title: 'المشاريع المكتملة',
      value: stats?.completed,
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      title: 'المشاريع المخططة',
      value: stats?.planned,
      icon: 'Clock',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      title: 'متوسط التقدم',
      value: `${stats?.avgProgress}%`,
      icon: 'TrendingUp',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      title: 'إجمالي الأعضاء',
      value: stats?.totalMembers,
      icon: 'Users',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
      {statCards?.map((stat, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-4 shadow-elevation-1">
          <div className="flex items-center justify-between mb-2">
            <div className={`w-10 h-10 ${stat?.bgColor} rounded-lg flex items-center justify-center`}>
              <Icon name={stat?.icon} size={20} className={stat?.color} />
            </div>
          </div>
          
          <div>
            <p className="text-2xl font-bold text-foreground mb-1">
              {stat?.value}
            </p>
            <p className="text-xs text-muted-foreground">
              {stat?.title}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProjectStats;